import moment from 'moment'
export default class Util {
    static dateFormat(val) {
        if (val == '') {
            return ''
        }
        let date = new Date(val);
        let date_value = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        return date_value
    }

    static getQueryVariable(paraName) {
        var reg = new RegExp("(^|&)" + paraName + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);//search,查询？后面的参数，并匹配正则
        if (r != null) return unescape(r[2]); return null;
    }

    static getPreDate(n) {
        var now = new Date;
        now.setDate(now.getDate() - n);
        return now;
    }

    static getMonthStart() {
        return moment(new Date()).format('YYYY-MM') + '-01';
    }

  


    static getNowFormatDate() {
        return moment(new Date()).format('YYYY-MM-DD');
    }

    static regIdCard(idCard) {
        let str = idCard.toString();
        var reg = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2]\d)|(3[0-1]))((\d{4})|(\d{3}[Xx]))$/;
        // 用于存储结果
        var result = {};
        if (reg.test(str)) {
            var sum = 0;
            var arrID = str.split("");
            var arrWi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            var arrY = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2];
            for (var i = 0; i < arrWi.length; i++) {
                sum += arrID[i] * arrWi[i];
            };
            sum %= 11;
            var lastID = arrID[arrID.length - 1];
            if (lastID == "X" || lastID == "x") {
                lastID = 10;
            };
            if (arrY[sum] == lastID) {
                result["check"] = true;
                result["birthday"] = str.substr(6, 8);
                result["cityCode"] = str.substr(0, 6);
                result["gender"] = (str.substr(14, 3) % 2 == 0) ? "女" : "男";
            } else {
                result["check"] = false;
                result["error"] = "身份证号码输入错误";
            }
        } else {
            result["check"] = false;
            result["error"] = "身份证号码格式有误";
        }
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/util/util.js